import { Component, OnInit } from "@angular/core";
import { TopVendorComponent } from "../top-vendor.component";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { NgIf } from "@angular/common";
import { RouterLinkActive, RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { DropdownComponent } from "../../../shared/dropdown/dropdown.component";
import { SharedSource } from "../../../core/shared-source";

@Component({
    selector: "app-top-vendor-mobile",
    templateUrl: "./top-vendor-mobile.component.html",
    styleUrls: ["./top-vendor-mobile.component.scss"],
    standalone: true,
    imports: [
        RouterLinkActive,
        RouterLink,
        NgIf,
        FormsModule,
        DropdownComponent,
    ],
})
export class TopVendorMobileComponent extends TopVendorComponent implements OnInit {
  
  navToggle: boolean = false;
  unseenEventsCount$: Observable<number>;

  ngOnInit(): void {
    // SELLER acts as its own company — nothing to bootstrap. ADMIN/VENDORMGR must pick a vendor.
    if (!this.vendorService.isImpersonatingRole) {
      return;
    }
    this.vendorService.pubSubSubscription.add(
      this.pubSubService.sharedSubject.subscribe(data => {
        if (data.name === SharedSource.offerSummary || data.name === SharedSource.bpUnseenEventCountUpdated) {
          this.cdr.detectChanges();
        }
      }));
    this.getAllCustomers();
  }

  toggleNav(e:Event) {
    if (e.isTrusted) {
      this.navToggle = !this.navToggle;
      if (this.navToggle) {
        document.documentElement.classList.add('is-modal');
      } else {
        document.documentElement.classList.remove('is-modal');
      }
    } else {
      return;
    }
  }

  closeNav() {
    this.navToggle = false;
    document.documentElement.classList.remove('is-modal');
  }

}
